import styled from 'styled-components'
import { tabletBreakpoint, desktopBreakpoint, wideScreenBreakpoint } from 'react-components'

export const Container = styled.section`
    width: inherit;
    overflow: hidden;
    padding: 1rem 0 0.5rem;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 2rem 1.5rem 1rem;
    }
    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        padding: 2rem 4rem 1rem;
    }
`

export const ReviewsWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;
    margin: 0.5rem 0 1.5rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        grid-template-columns: repeat(3, 1fr);
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        grid-template-columns: repeat(3, 1fr);
    }
`

export const SliderContainer = styled.div`
    position: ${props => props.theme.style.position.relative};
    max-width: fit-content;
    overflow: hidden;
    margin-top: 0.5rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin-top: 1rem;
    }
`

export const StyledCarouselProvider = styled.div<{ margin?: string; center?: boolean }>`
    width: 100%;
    margin: ${({ margin }) => (margin ? margin : 0)};
    li {
        list-style: none;
    }
`

export const StyledSlider = styled.div`
    padding: 0;
`
